export const commments = {
  agd: { id: 'agd' },
  coldWater: { id: 'cold_water' },
  wolfAttack: { id: 'wolf_attack' },
  lowTransparency: { id: 'low_transparency' },
  microalgaeBloom: { id: 'microalgae_bloom' },
  networkChange: { id: 'network_change' },
  strongCurrent: { id: 'strong_current' },
  badWeather: { id: 'bad_weather' },
  handlingInjection: { id: 'handling_injection' },
  handlingByPath: { id: 'handling_by_bath' },
  sampling: { id: 'sampling' },
  lowOxygen: { id: 'low_oxygen' },
  plankton: { id: 'plankton' },
  healthProblems: { id: 'health_problems' },
  agdTreatment: { id: 'agd_treatment' },
  parasiteTreatment: { id: 'parasite_treatment' },
  brightnessTreatment: { id: 'brightness' },
  manualFeeding: { id: 'manual_feeding' },
  feedingStrategy: { id: 'feeding_strategy' },
  preHarvestFast: { id: 'pre_harvest_fast' },
}
